import { Observable } from 'rxjs';
import { SalesTeamsService } from '../../filters/salesteam-multi-select/tokens';
import { InjectionToken } from '@angular/core';

export interface PipelineTableFilterChipsConfig {
  hasAccessToAllAccountsInMarket$: Observable<boolean>;
  salesTeamsService: SalesTeamsService;
}

export const PIPELINE_TABLE_FILTER_CHIPS_CONFIG_TOKEN = new InjectionToken<PipelineTableFilterChipsConfig>(
  'general dependency data for the pipeline table filter chips',
);
